import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DxValidationGroupComponent } from 'devextreme-angular/ui/validation-group';
import notify from 'devextreme/ui/notify';
import { isEmpty, merge } from 'lodash-es';
import sum from 'lodash-es/sum';
import moment from 'moment';
import { utc } from 'moment/moment';
import { combineLatest, of } from 'rxjs';
import { catchError, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { oc } from 'ts-optchain';
import { discretizeDates } from '../../../../shared/classes/utils/time.utils';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { ABaseComponent } from '../../../../shared/modules/ui/components/abstract/a-base.component';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import {
  AuthService,
  AuthServiceApi,
  Consumer,
  ConsumerApi,
  LoggerService,
  TripManifestRec,
  TripRec,
  TripRecApi,
} from '../../../../shared/sdk';
import { AuthClaimService } from '../../../service-authorization/services/auth-claim.service';
import { INavinetAuthDoc } from '../../../service-authorization/services/auth-claim.type';

@Component({
  selector: 'app-dlg-meal-units-edit',
  templateUrl: './dlg-meal-units-edit.component.html',
  styleUrls: ['./dlg-meal-units-edit.component.scss'],
  providers: [AuthClaimService],
})
export class DlgMealUnitsEditComponent extends ABaseComponent implements OnInit {
  @ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent;

  items = [
    {
      code: 'W1759',
      name: 'Hot',
      config: 'meals_Hot_W1759_Enabled',
    },
    {
      code: 'W1760',
      name: 'Frozen',
      config: 'meals_Frozen_W1760_Enabled',
    },
    {
      code: 'W1761',
      name: 'Sandwich',
      config: 'meals_Sandwich_W1761_Enabled',
    },
    {
      code: 'W1762',
      name: 'Emergency',
      config: 'meals_Emergency_W1762_Enabled',
    },
    {
      code: 'W1764',
      name: 'Special',
      config: 'meals_Special_W1764_Enabled',
    },
  ];

  value: { [code: string]: { [month: string]: number } } = {};

  usedMonthsMap: { [code: string]: Record<string, number> } = {};
  authorizedMonthsMap: { [code: string]: Record<string, number> } = {};
  allowedMonthsMap: { [code: string]: Record<string, number> } = {};

  private mci: string;
  private auths: INavinetAuthDoc[] = [];
  private prevRecs: TripRec[];

  // minDate: Date;
  // maxDate: Date;

  prevMonth: string;
  curMonth: string;
  nextMonth: string;
  months: string[];

  // popupVisible = false;
  // draftCode: string;

  // tagBoxButtonsMap = Object.fromEntries(
  //   ['W1759', 'W1760', 'W1761', 'W1762', 'W1764'].map(
  //     c =>
  //       [
  //         c,
  //         [
  //           'clear',
  //           {
  //             name: 'add',
  //             location: 'after',
  //             options: {
  //               icon: 'add',
  //               hint: 'Add date',
  //               stylingMode: 'text',
  //               onClick: e => {
  //                 // console.log(e);
  //                 this.draftCode = c;
  //                 this.popupVisible = true;
  //               },
  //             },
  //           },
  //         ],
  //       ] as [string, dxTextEditorButton[]],
  //   ),
  // );

  constructor(
    protected logger: LoggerService,
    private dialogRef: MatDialogRef<DlgMealUnitsEditComponent, any>,
    @Inject(MAT_DIALOG_DATA) private data: { rec: TripManifestRec; date: string },
    public config: ConfigService,
    private dss: DataSourceService,
    private service: AuthClaimService,
    private ui: UiService,
  ) {
    super(logger);

    const som = moment(this.date).startOf('month');

    this.curMonth = som.clone().format('YY-MM');
    this.prevMonth = som.clone().subtract(1, 'month').format('YY-MM');
    this.nextMonth = som.clone().add(1, 'month').format('YY-MM');

    this.months = [this.prevMonth, this.curMonth, this.nextMonth];
  }

  get date() {
    return this.data.date;
  }

  ngOnInit() {
    super.ngOnInit();
    // console.log(this.data);

    this.ui.showLoading();

    {
      this.service.getProcedureCodes().map(code => {
        this.value[code] = {};
        this.authorizedMonthsMap[code] = {};
        this.usedMonthsMap[code] = {};
        this.allowedMonthsMap[code] = {};

        for (const month of [this.prevMonth, this.curMonth, this.nextMonth]) {
          this.value[code][month] = 0;
          this.authorizedMonthsMap[code][month] = 0;
          this.usedMonthsMap[code][month] = 0;
          this.allowedMonthsMap[code][month] = 0;
        }
      });

      this.value = merge(this.value, oc(this.data).rec.mu_v2({}));
    }

    // this.minDate = moment(this.date).subtract(1, 'month').toDate();
    // this.maxDate = moment(this.date).add(1, 'month').toDate();

    combineLatest([this.getMember$(this.data.rec.c), this.getPrevRecs$(this.data.rec.c, this.date)])
      .pipe(
        switchMap(([c, prevRecs]) =>
          this.getMemberAuths$(c.mci, this.date).pipe(map(auths => ({ c, prevRecs, auths }))),
        ),
        tap(({ c, prevRecs, auths }) => {
          this.mci = c.mci;
          this.prevRecs = prevRecs;
          this.auths = auths;

          // console.log(this.prevRecs);

          {
            const som = moment(this.date).startOf('month');
            const sopm = som.clone().subtract(1, 'month');
            const sonm = som.clone().add(1, 'month');

            const months = [sopm, som, sonm].map(m => m.format('YY-MM'));

            this.usedMonthsMap = Object.fromEntries(
              this.service.getProcedureCodes().map(code => {
                const prevMonths = this.prevRecs.map(r => oc(r).mealsUnitsV2[code]({}) as { [month: string]: number });

                const codeMap: Record<string, number> = {};
                for (const month of months) {
                  codeMap[month] = sum(prevMonths.map(pm => pm[month] || 0));
                }

                return [code, codeMap];
              }),
            );

            this.authorizedMonthsMap = Object.fromEntries(
              this.service.getProcedureCodes().map(code => {
                const cAuths = this.auths.filter(a => a.Code === code);
                const codeMap: Record<string, number> = {};
                for (const month of months) {
                  const socm = moment(month + '-01', 'YY-MM-DD');
                  const dates = discretizeDates(socm, socm.clone().add(1, 'month'));
                  codeMap[month] = this.service.getUnitsByDates(cAuths, dates);
                }

                return [code, codeMap];
              }),
            );

            this.allowedMonthsMap = Object.fromEntries(
              this.service.getProcedureCodes().map(code => {
                const codeMap: Record<string, number> = {};

                for (const month of months) {
                  codeMap[month] = this.authorizedMonthsMap[code][month] - this.usedMonthsMap[code][month];
                }

                return [code, codeMap];
              }),
            );
          }
        }),
        catchError(err => of(notify(err.message, 'error', 5000))),
        tap(() => {
          this.ui.hideLoading();
        }),
        takeUntil(this.$onDestroy$),
      )
      .subscribe();
  }

  // dateExpr(item: string) {
  //   return moment(item).format('MM/DD');
  // }
  //
  // dateSelected(data) {
  //   return oc(this).value[this.draftCode].dates([]).includes(moment(data.date).format('YYYY-MM-DD'));
  // }
  //
  // dateUnits(data) {
  //   const units = this.getUnitsByDates(this.draftCode, [moment(data.date).format('YYYY-MM-DD')]);
  //   return units > 0 ? units : '';
  // }

  // confirmAdd(e: DxComponentEvent<dxCalendar> & { value }) {
  //   const code = this.draftCode;
  //
  //   if (oc(this).value[code].dates([]).includes(e.value)) {
  //     this.value[code].dates = Array.from(new Set(difference(oc(this).value[code].dates([]), [e.value]))).sort();
  //   } else {
  //     this.value[code].dates = Array.from(new Set(compact([...oc(this).value[code].dates([]), e.value]))).sort();
  //   }
  //
  //   // this.popupVisible = false;
  // }

  // datesValueChanged(e, code: string) {
  //   this.value[code].dates = e.value;
  //   this.value[code].u = this.getUnitsByDates(code, oc(this).value[code].dates([]));
  // }

  // validateDates(code: string) {
  //   return (e: any) => {
  //     if (this.value[code].u === 0) return true;
  //     return e.value.length > 0;
  //   };
  // }
  //
  // validateQuantity(code: string) {
  //   return (e: { value: number }) => {
  //     const allowed = this.getUnitsByDates(code, oc(this).value[code].dates([]));
  //     return e.value === allowed;
  //   };
  // }

  // disableDates = args => {
  //   return !this.allowedDatesMap[this.draftCode].has(moment(args.date).format('YYYY-MM-DD'));
  // };

  validateGroup() {
    const result = this.validationGroup.instance.validate();

    if (result.isValid) {
      this.dialogRef.close(this.value);
    }
  }

  private getMember$(cId: number) {
    return this.dss.getApi<ConsumerApi>(Consumer).findById<Consumer>(cId, { fields: { mci: true } });
  }

  private getMemberAuths$(mci: string, date: string) {
    const som = utc(date).startOf('month');
    const sopm = som.clone().subtract(1, 'month');
    const eonm = som.clone().add(1, 'month').endOf('month');

    const pipeline = [
      {
        $match: {
          _inactive: { $ne: true },
          _mci: mci,
          Code: { $in: this.service.getProcedureCodes() },
          $expr: {
            $and: [
              { $lte: ['$StartDT', { $dateFromString: { dateString: utc(eonm).toISOString() } }] },
              { $gte: ['$EndDT', { $dateFromString: { dateString: utc(sopm).toISOString() } }] },
            ],
          },
        },
      },
      { $project: { _source: 0 } },
      {
        $sort: {
          StartDT: 1,
          _ctime: 1,
        },
      },
    ];

    return this.dss
      .getApi<AuthServiceApi>(AuthService)
      .getAndFilterAuths(pipeline)
      .pipe(
        map((auths: INavinetAuthDoc[]) =>
          auths.filter(auth => !auth.__replaced).filter(auth => !isEmpty(oc(auth)._manifest({}))),
        ),
      );
  }

  private getPrevRecs$(cId: number, date: string) {
    const som = utc(date).startOf('month');
    const soppm = som.clone().subtract(2, 'month');
    const eonm = som.clone().add(1, 'month').endOf('month');

    return this.dss.getApi<TripRecApi>(TripRec).find<TripRec>({
      where: {
        and: [
          { consumerId: cId },
          { date: { gte: soppm.toDate() } },
          { date: { lte: eonm.toDate() } },
          { date: { neq: utc(date).toDate() } },
          { mealsUnitsV2: { neq: null } },
        ],
      },
      fields: { mealsUnitsV2: true, date: true },
    });
  }

  formatMonth(yymm: string) {
    const m = moment(yymm, 'YY-MM');
    return m.format('MM/YY');
  }
}
